<div class="table-layout">
  <ion-grid class="p-0 h-100">
    <ion-row class="p-0 mb-20">
      <ion-col class="p-0 display-space-between" size="12">
        <div>
          <ion-label class="font_bold black_color" *ngIf="buttonName != 'Repository'">{{buttonName}}
            ({{gridData.totalCount}})</ion-label>
          <ion-label class="font_bold black_color" *ngIf="buttonName == 'Repository'">{{buttonName}} :
            ({{loggedInCompanyIndustryName}})</ion-label>
        </div>
        <mat-form-field class="w-30 mat-height40 mat-input-style">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" [(ngModel)]="searchText" (input)="onSearch(searchText)">
        </mat-form-field>
        <div class="display-end p-0">
          <!-- <button *ngIf="buttonName == 'Previous Months KPI' && goalSettingAtAllLevels" (click)="useKpiForThisMonth()" type="button"
            class="add_btn fs-14 mr-10" [ngClass]="{'disableBtn' : selectedKPIList.length == 0}"
            [disabled]="selectedKPIList.length == 0" [style.background-color]="buttonColorName">Use KPI for this Month
          </button> -->
          <button [ngClass]="{'disableBtn' : renderData.length == 0}" [disabled]="renderData.length == 0" type="button"
            class="back_btn mr-40 d-flex" (click)="downloadKpis()">
            <span class="material-icons mr-5">download</span>Download</button>
          <img [mat-dialog-close] src="././assets/icon/close_icon.png" class="cp fixed">
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="buttonName == 'Previous Months KPI' && goalSettingAtAllLevels">
      <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
        <ng-multiselect-dropdown class="d-flex" [placeholder]="'Select Months'" [settings]="dropdownSettings"
          [data]="notApprovedMonths" [(ngModel)]="selectedMonthsForKpiAdd" (onSelectAll)="selectAllMonths($event)"
          (onDeSelectAll)="onDeSelectAllMonths()"></ng-multiselect-dropdown>
      </ion-col>
      <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8">
        <div class="center-content">
          <button (click)="copyPreviousKPI()"
          type="button" class="add_btn fs-14 mr-10" [ngClass]="{'disableBtn' : selectedKPIList.length == 0 || selectedMonthsForKpiAdd.length == 0}"
          [disabled]="selectedKPIList.length == 0 && selectedMonthsForKpiAdd.length == 0" [style.background-color]="buttonColorName">Paste
        </button>
        <label *ngIf="selectedKPIList.length != 0" class="formLabelSemiBoldfs14 mb-5">Total Selected KPIs Weightage:&nbsp;{{totalSelectedWtCount}}</label>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="buttonName == 'Repository'" class="mb-10">
      <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
        <div class="formLabelSemiBoldfs14 mb-5">Sub Industries<span class="red-cl">&nbsp;*</span></div>
        <ng-multiselect-dropdown class="d-flex" [placeholder]="'Select Sub Industries'" [settings]="dropdownSettings"
          [data]="subIndustriesList" [(ngModel)]="selectedSubIndustries" (onSelect)="getRepositoryKPIs()"
          (onDeSelect)="getRepositoryKPIs()" (onSelectAll)="selectAllSubIndusries($event)"
          (onDeSelectAll)="onDeSelectAllSubIndusries()"></ng-multiselect-dropdown>

        <!-- <ng-select [closeOnSelect]="false" placeholder="Select Sub Industries" [multiple]="true" class="w-100"
          [(ngModel)]="selectedSubIndustries" (change)="getRepositoryKPIs()">
          <ng-option [value]="item.id" *ngFor="let item of subIndustriesList">{{item.name}}</ng-option>
        </ng-select> -->
      </ion-col>
      <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
        <div class="formLabelSemiBoldfs14 mb-5">Dept/Function<span class="red-cl">&nbsp;*</span></div>
        <ng-multiselect-dropdown class="d-flex" [placeholder]="'Select Dept/Function'" [settings]="dropdownSettings"
          [data]="functionList" [(ngModel)]="selectedFunction" (onSelect)="getRepositoryKPIs()"
          (onDeSelect)="getRepositoryKPIs()" (onSelectAll)="selectAllFunctions($event)"
          (onDeSelectAll)="onDeSelectAllFunctions()"></ng-multiselect-dropdown>

        <!-- <ng-select [closeOnSelect]="false" placeholder="Select Function" [multiple]="true" class="w-100"
          [(ngModel)]="selectedFunction" (change)="getRepositoryKPIs()">
          <ng-option [value]="item" *ngFor="let item of functionList">{{item}}</ng-option>
        </ng-select> -->
      </ion-col>
      <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
        <div class="formLabelSemiBoldfs14 mb-5">Designation<span class="red-cl">&nbsp;*</span></div>
        <ng-multiselect-dropdown class="d-flex" [placeholder]="'Select Designation'" [settings]="dropdownSettings"
          [data]="designationList" [(ngModel)]="selectedDesignation" (onSelect)="getRepositoryKPIs()"
          (onDeSelect)="getRepositoryKPIs()" (onSelectAll)="selectAllDesignation($event)"
          (onDeSelectAll)="onDeSelectAllDesignation()"></ng-multiselect-dropdown>
        <!-- <ng-select [closeOnSelect]="false" placeholder="Select Designation" [multiple]="true" class="w-100"
          [(ngModel)]="selectedDesignation" (change)="getRepositoryKPIs()">
          <ng-option [value]="item" *ngFor="let item of designationList">{{item}}</ng-option>
        </ng-select> -->
      </ion-col>
    </ion-row>
    <ion-row class="p-0 mb-10">
      <ion-col class="p-0">
        <div>
          <table class="hover">
            <thead>
              <tr>
                <th class="width1 mat-checkbox-style"
                  *ngIf="buttonName == 'Previous Months KPI' && goalSettingAtAllLevels">
                  <mat-checkbox [(ngModel)]="selectAllCheckbox" [checked]="selectAllCheckbox==true" value=true
                    (change)="selectALLRecords($event)"></mat-checkbox>
                </th>
                <th [ngClass]="{'p-5' : buttonName != 'Previous Months KPI' || !goalSettingAtAllLevels}"
                  class="fs-16 font_regular cl-black" *ngFor="let item of gridData.columnInfo">
                  <label class="verticle-center icon-style">{{item.label}}
                    <!-- <div class="d-flex flex-column ml-10" *ngIf="item.label != 'Action'">
                      <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'"
                        (click)="onSortAssending(item)">arrow_drop_up</i>
                      <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'"
                        (click)="onSortDesending(item)">arrow_drop_down</i>
                    </div> -->
                  </label>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white" *ngIf="renderData.length !== 0">
              <tr *ngFor="let item of renderData;let i=index">
                <td class="width1 mat-checkbox-style"
                  *ngIf="buttonName == 'Previous Months KPI' && goalSettingAtAllLevels">
                  <mat-checkbox [(ngModel)]="item.checkboxCheck" [checked]="item.checkboxCheck" value=true
                    (change)="selectSingleRecord($event,item,i)"></mat-checkbox>
                </td>
                <ng-container *ngFor="let innerItem of item">
                  <td [ngClass]="{'p-5' : buttonName != 'Previous Months KPI' || !goalSettingAtAllLevels}"
                    *ngIf="innerItem.key !== 'id'" class="fs-16 font_regular">{{innerItem.value}}</td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </ion-col>
      <ion-col size="12" class="p-0" *ngIf="renderData.length === 0">
        <div class="bg-white text-center font_medium">No Data Available</div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="renderData.length != 0">
      <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8" class="center-content">
        <ion-label *ngIf="buttonName != 'Previous Months KPI'" class="fs-14 font_bold black_color">Showing {{showingCount}} to {{showingOfCount}} of
          {{gridData.totalCount}} entries</ion-label>
          <ion-label *ngIf="buttonName == 'Previous Months KPI'" class="fs-14 font_bold black_color">
            {{gridData.totalCount}} entries</ion-label>
      </ion-col>
      <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="text-right display-end">
        <ul class="dt_pagination" *ngIf="buttonName != 'Previous Months KPI'">
          <ion-row class="float-right pgintn">
            <li class="active fs-16 font_regular">{{currentPageNumberOfKpis}}</li>
            <span class="fs-14 font_regular p-10">of {{gridData.totalNoOfPages}}</span>
            <li class="fs-24 cp" (click)="previousPageKpi()" [ngClass]="{'disableBtn': currentPageNumberOfKpis==1}">&lt;
            </li>
            <li class="fs-24 cp" (click)="nextPageKpi()"
              [ngClass]="{'disableBtn': currentPageNumberOfKpis >= gridData.totalNoOfPages}">&gt;</li>
          </ion-row>
        </ul>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>